import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Consorcio } from '../../model/consorcio';
import { Moneda } from '../../model/moneda';

import { CatalogoCobro } from '../../model/catalogo-cobro';


import { ConsorciosService } from '../../services/consorcios.service';
import { CatalogoCobroService } from '../../services/catalogo-cobro.service';
import { MonedaService } from '../../services/moneda.service';


@Component({
  selector: 'app-catalogo-cobro-mantenimiento',
  templateUrl: './catalogo-cobro-mantenimiento.component.html',
  styleUrls: ['./catalogo-cobro-mantenimiento.component.css']
})
export class CatalogoCobroMantenimientoComponent implements OnInit {


  @Input() consorcio: Consorcio = new Consorcio();
  @Input() catalogoSeleccionado: CatalogoCobro;
  @Output() onReturn = new EventEmitter();

  public catalogo: CatalogoCobro = new CatalogoCobro();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public monedas: Moneda[];

  public descripcion: string;
  public errorMessage: any;

  constructor(
    private _consorcioService: ConsorciosService,
    private _catalogoService: CatalogoCobroService,
    private _monedaService: MonedaService
  ) { }

  ngOnInit() {
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this._monedaService.getMonedas().subscribe(
      data => this.monedas = data,
      error => console.log(error));

    this.catalogo = this.catalogoSeleccionado;

    if (this.catalogo.id != undefined) {
      this.estadoEditar = true;
    } else {
      this.catalogo = new CatalogoCobro();
    }
  }

  /* Navegación */

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  /* Fin navegación */

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  onSubmit() {
    if (this.catalogo.id === undefined) {
      this.catalogo.id = 0;
    }

    this.catalogo.codigoConsorcio = this.consorcio.codigoConsorcio;
    this._catalogoService.insert(this.catalogo).subscribe(
      result => { 
        if(result.Resultado === "id ya existe en la base de datos"){
            alert("El código del Cobro ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      },
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  borrarRegistro() {
    this._catalogoService.delete(this.catalogo).subscribe(
      result => this.regresar(),
      err => {
        console.log(err._body);
      });
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/catalogo-cobro-mantenimiento/catalogo-cobro-mantenimiento.component.ts